import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Card } from '@components/molecules/Card/Card';
import { ColumnsLayout } from '@components/templates/ColumnsLayout/ColumnsLayout';

import { useGuestLogin } from '@utils/hooks/useGuestLogin';
import { useGetServiceRedirect } from '@utils/hooks/useServiceRedirect';

import { getPath } from '@services/RouteService/paths';

import { FormBottomElement } from '@domains/auth/molecules/FormBottomElement/FormBottomElement';
import { LoginBanner } from '@domains/auth/molecules/LoginBanner/LoginBanner';
import { GuestLoginForm } from '@domains/auth/organisms/GuestLoginForm/GuestLoginForm';
import { LoginGuestBanner } from '@domains/auth/pages/LoginGuestPage/LoginGuestPage.styled';

export const LoginGuestPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { openGuestModal, sessionProcessing } = useGuestLogin();
    const { isSurveysRedirect } = useGetServiceRedirect();

    return (
        <ColumnsLayout>
            <Card testId="GWo_ioi">
                <Card.Title>{t('CONTINUE_AS_A_GUEST')}</Card.Title>
                <Card.Description>
                    {t('GUEST_REGISTER_DESCRIPTION')}
                </Card.Description>
                <GuestLoginForm
                    bottomElement={
                        isSurveysRedirect ? (
                            <FormBottomElement
                                buttonText={t('GUEST_LOGIN')}
                                onSubmit={() =>
                                    navigate(
                                        getPath({
                                            path: '/auth/login',
                                        }),
                                    )
                                }
                            />
                        ) : undefined
                    }
                    loading={sessionProcessing}
                    openGuestModal={openGuestModal}
                />
            </Card>
            <LoginGuestBanner>
                <LoginBanner.Title>
                    <LoginBanner.Link to={getPath({ path: '/auth/signup' })}>
                        {t('CREATE_SPEEKI_ACCOUNT')}
                    </LoginBanner.Link>{' '}
                    {t('IF')}:
                </LoginBanner.Title>
                <LoginBanner.List>
                    <LoginBanner.ListItem>
                        {t('GUEST_REGISTER_LIST_TEXT_1')}
                    </LoginBanner.ListItem>
                    <LoginBanner.ListItem>
                        {t('GUEST_REGISTER_LIST_TEXT_2')}
                    </LoginBanner.ListItem>
                </LoginBanner.List>
            </LoginGuestBanner>
        </ColumnsLayout>
    );
};
